import config from "../config/config.json";
import { headers } from "./../APIHelpers/Headers";
import { headersWithAuthWithoutBody } from "../APIHelpers/Responses";

export const adminDashboardServices = {
  getAdminDashboardSummary,
};

async function getAdminDashboardSummary() {
  const response = await fetch(
    `${config.API_URL}getAdminDashboardSummary`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}
